import {ERROR_LEVELS} from "@/constants";
import {VNode} from "vue";

/**
 * エラーレベル
 */
export type ErrorLevelType = keyof typeof ERROR_LEVELS;

/**
 * エラーメッセージ
 */
export default interface ErrorMessage {
  /** エラーレベル */
  level: ErrorLevelType;

  /** エラーメッセージ */
  message: string | VNode | (VNode | string)[];
}

/**
 * ErrorLevelType を数値に置き換えます
 *
 * @param errorLevel ErrorLevelType
 */
export function errorLevelToNumber(errorLevel: ErrorLevelType): number {
  switch(errorLevel) {
    case 'error': return 4;
    case 'warn':  return 3;
    case 'info':  return 2;
    case 'good':  return 1;
    case 'none':  return 0;
    default: throw new Error(`Invalid error level string: ${errorLevel}`);
  }
}

/**
 * errorLevelToNumber で得られた数値を ErrorLevelType に置き換えます
 *
 * @param errorNumber errorLevelToNumber で得られた数値
 */
export function errorNumberToLevel(errorNumber: number): ErrorLevelType {
  switch(errorNumber) {
    case 4:  return 'error';
    case 3:  return 'warn';
    case 2:  return 'info';
    case 1:  return 'good';
    case 0:  return 'none';
    default: throw new Error(`Invalid error level number: ${errorNumber}`);
  }
}

/**
 * 指定されたすべての ErrorMessage の中で最もレベルの高い ErrorLevel を取得します
 *
 * @param messages ErrorMessage の配列
 */
export function maxErrorLevel(messages: ErrorMessage[]): ErrorLevelType {
  return errorNumberToLevel(
      messages
        .map(m => errorLevelToNumber(m.level))
        .reduce((cur, prev) => Math.max(cur, prev), 0)
  );
}
